module.exports = __webpack_public_path__ + "img/00449149920013.acf97829.png";